import { CSA_TENANT_FAILURE,TENANT_FAILURE, TENANT_SUCCESS, TENANT_REQUEST, TENANT_DELETE,GETTOKEN_FAILURE,GETTOKEN_REQUEST,GETTOKEN_SUCCESS } from "../constants/ActionTypes";

const initialState = {
    loading: false,
    connection_id: null,
    tenantLogoURL: null,
    error: null,
    login_image: null,
    OFN_enabled: null,
    Order_type: null,
    configDetails:[]
    // window.location.hostname
    
};


export default function tenantReducer(state = initialState, action) {
    switch (action.type) {
        case TENANT_REQUEST:
            return {
                ...state,
                loading: true,
            };
        case TENANT_SUCCESS:
            return {

                ...state,
                loading: false,
                // always replacing data
                connection_id: action.data.connection_id,
                Order_type: action.data.Order_type,
                OFN_enabled: action.data.OFN_enabled,
                tenantLogoURL: action.data.tenantLogoURL,
                header_and_store_content: action.data.header_and_store_content,
                stylesheet_properties: action.data.stylesheet_properties,
                tenant_details: action.data.tenant_details,
                pshop_keyword_search : action.data.pshop_keyword_search,
                pshop_product_search : action.data.pshop_product_search,
                presentURL : window.location.hostname,
                store_details: action.data.store_details,
                login_image: action.data.login_image,
            };
        // case TENANT_DELETE:
        //     return {
        //         ...state,
        //         loading: false,
        //         // always replacing data
        //         user_details: [],
        //         isAuth: false
        //     };
        case TENANT_FAILURE:
            return {
                ...state,
                loading: false,
                error: action.error,
            };
             case GETTOKEN_REQUEST:
            return {
                ...state,
                loading: true,
            };
        case GETTOKEN_SUCCESS:
            return {

                ...state,
                loading: false,
                configDetails: action.data,
    
            };
        
        case GETTOKEN_FAILURE:
            return {
                ...state,
                loading: false,
                error: action.error,
            };

        default:
            return state;
    }
}
